"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../../Utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EyeDropperIcon = function EyeDropperIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-icon-eyedropper"),
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.83753 1.46199L8.53796 0.162415C8.48658 0.11093 8.42555 0.0700837 8.35836 0.0422144C8.29118 0.014345 8.21916 0 8.14642 0C8.07368 0 8.00166 0.014345 7.93448 0.0422144C7.86729 0.0700837 7.80626 0.11093 7.75488 0.162415L6.02212 1.89518L4.95081 0.836359L4.16773 1.61943L4.95664 2.40834L0.00244141 7.36004V10H2.6399L7.59327 5.04664L8.38217 5.83554L9.16525 5.05247L8.09894 3.98615L9.83253 2.25256C9.88507 2.20135 9.92694 2.14023 9.95571 2.07273C9.98447 2.00523 9.99956 1.93269 10.0001 1.85932C10.0006 1.78595 9.98663 1.7132 9.95887 1.64529C9.9311 1.57737 9.89014 1.51563 9.83836 1.46365L9.83753 1.46199ZM2.17922 8.88703L1.11291 7.82072L5.58893 3.3447L6.65524 4.41101L2.17922 8.88703Z",
    fill: "#B1B2B3"
  }));
};
var _default = EyeDropperIcon;
exports.default = _default;